import classNames from 'classnames/bind';
import React, { useRef, useEffect, useMemo } from 'react';
import { useDispatch, useStore } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import Checkbox from '@/components/ui/kit/Checkbox';
import { FieldNumber } from '@/components/ui/kit/Field';
import { getElevation } from '@/utils/MapUtils';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const store = useStore();
  const domRefs = useRef({
    latitude: useRef(),
    longitude: useRef(),
    elevation: useRef(),
  }).current;

  const hasParachute = useMemo(() => {
    return command.data.parachute === true;
  }, [command.data]);

  const specs = useMemo(() => {
    return store.getState().mission.json.specs;
  }, []);

  useEffect(() => {
    domRefs.latitude.current.value = command.data.position.lat.toFixed(7);
    domRefs.longitude.current.value = command.data.position.lng.toFixed(7);
    domRefs.elevation.current.value = command.data.elevation;
  }, [command.data]);

  const updatePosition = (position) => {
    getElevation(position).then((elevation) => {
      const waypoint = { position, elevation };
      dispatch(actions.mission.moveWaypoint(command.id, waypoint));
    });
  };

  const handleBlur = (e) => {
    const name = e.target.name;
    const value = Number(e.target.value);

    // Latitude 변경된 경우
    if (name === 'latitude') {
      updatePosition({ lat: value, lng: command.data.position.lng });
    }
    // Longitude 변경된 경우
    else if (name === 'longitude') {
      updatePosition({ lat: command.data.position.lat, lng: value });
    }
  };

  const toggleParachute = () => {
    dispatch(actions.mission.editWaypoint(index, 'parachute', !hasParachute));
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Latitude">
        <FieldNumber ref={domRefs.latitude} name="latitude" min={-85} max={85} onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Longitude">
        <FieldNumber ref={domRefs.longitude} name="longitude" min={-180} max={180} onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Elevation" unit="m">
        <FieldNumber ref={domRefs.elevation} name="elevation" readOnly />
      </FieldRow>
      {specs.firmware === 'ardupilot' && (
        <FieldRow label="Parachute">
          <Checkbox checked={hasParachute} onClick={toggleParachute} />
        </FieldRow>
      )}
    </div>
  );
};

export default Command;
